import React, { useState } from 'react'
import { DocumentAddIcon, PencilIcon } from '@heroicons/react/outline'

import ValuePropTable from './Table/ValuePropTable'
import ValuePropGenerate from './Modals/ValuePropGenerate'
import EditModal from './Modals/EditModal'
import DeleteModal from './Modals/DeleteModal'
import CallToActionModal from './Modals/CallToActionModal'
import ContextTypeModal from './Modals/ContextTypeModal'
import TemplateModal from './Modals/TemplateModal'
// import Toggle from './Table/Toggle'
import TemplateTable from './Table/TemplateTable'
import EditTemplateModal from './Modals/EditTemplateModal'

function MainMessaging({
    FBvalueProp,
    auth,
    profile,
    callToAction
}) {

    const [ showVpropMod, setShowVpropMod ] = useState(false)
    const [ showEditMod, setShowEditMod ] = useState(false)
    const [ showDelete, setShowDelete ] = useState(false)
    const [ deleteID, setDeleteID ] = useState('')
    const [ deleteTitle, setDeleteTitle ] = useState('')
    const [ showCTA, setShowCTA ] = useState(false)
    const [ error, setError ] = useState('')
    const [ showContextType, setShowContextType ] = useState(false)
    const [ showTempMod, setShowTempMod ] = useState(false)

    const [ editTitle, setEditTitle ] = useState('')
    const [ editVprop, setEditVprop ] = useState('')
    const [ editPain, setEditPain ] = useState('')
    const [ editId, setEditId ] = useState('')
    // const [ enabled, setEnabled] = useState(false)
    const enabled = false
    const [ editTemp, setEditTemp ] = useState('')
    const [ showEditTempMod, setShowEditTempMod ] = useState(false)


    const handleEdit = (e) =>{
        // console.log(e)
        setEditId(e.id)
        setEditPain(e.Pain)
        setEditVprop(e.ValueProp)
        setEditTitle(e.Title)
        setEditTemp(e.Template)

        console.log(e)

        if (e.ContextType === 'template'){
            setShowEditTempMod(true)
        } else {
            setShowEditMod(true)
        }
    }

    const handleDelete = (e) =>{
        setDeleteID(e.id)
        setShowDelete(true)
        setDeleteTitle(e.Title)
    }


    return (
        <div style={{marginTop:-15}}>
            <div className="flex w-full">
              <h1 className="text-2xl font-semibold text-gray-900 mt-0 mb-6">Context</h1>
              <div className="ml-auto">
                <button 
                className="bg-green-500 mr-3 border-2 border-green-500 px-4 py-2 font-semibold text-white hover:bg-green-600 focus:outline-none rounded-lg"
                onClick={() => setShowCTA(true)}
                >
                    <span className="flex">
                        <PencilIcon className="h-5 mr-2"/>Edit Call To Action
                    </span>
                </button>
                <button 
                className="bg-blue-500 border-2 border-blue-500 px-4 py-2 font-semibold text-white hover:bg-blue-800 focus:outline-none rounded-lg"
                onClick={() => setShowVpropMod(true)}
                >
                    <span className="flex">
                        <DocumentAddIcon className="h-5 mr-2"/>Add Context
                    </span>
                </button>
              </div>
            </div>
            {/* <div className="mb-4">
                <Toggle 
                enabled={enabled}
                setEnabled={setEnabled}
                />
            </div> */}
            {enabled ?
            <TemplateTable 
            FBvalueProp={FBvalueProp}
            showEditMod={showEditMod}
            setShowEditMod={setShowEditMod}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            />
            :
            <ValuePropTable 
            FBvalueProp={FBvalueProp}
            showEditMod={showEditMod}
            setShowEditMod={setShowEditMod}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            />
            }
            {showContextType ?
            <div>
                <ContextTypeModal 
                setShowContextType={setShowContextType}
                showContextType={showContextType}
                setShowVpropMod={setShowVpropMod}
                setShowTempMod={setShowTempMod}
                />
            </div>
            :
            null
            }
            {showTempMod ?
            <TemplateModal 
            setShowTempMod={setShowTempMod}
            showTempMod={showTempMod}
            profile={profile}
            />
            :
            null
            }
            {showVpropMod ?
            <div>
                <ValuePropGenerate 
                showVpropMod={showVpropMod}
                setShowVpropMod={setShowVpropMod}
                auth={auth}
                profile={profile}
                FBvalueProp={FBvalueProp}
                setError={setError}
                error={error}
                />
            </div>
            :
            null
            }
            {showEditMod ?
            <EditModal 
            setShowEditMod={setShowEditMod}
            showEditMod={showEditMod}
            editTitle={editTitle}
            editPain={editPain}
            editId={editId}
            editVprop={editVprop}
            profile={profile}
            />
            :
            null
            }
            {showEditTempMod ?
            <EditTemplateModal 
            setShowEditTempMod={setShowEditTempMod}
            showEditTempMod={showEditTempMod}
            editTitle={editTitle}
            // editPain={editPain}
            editTemp={editTemp}
            editId={editId}
            // editVprop={editVprop}
            profile={profile}
            />
            :
            null
            }
            {showDelete ?
            <DeleteModal 
            deleteID={deleteID}
            setShowDelete={setShowDelete}
            showDelete={showDelete}
            profile={profile}
            deleteTitle={deleteTitle}
            />
            :
            null
            }
            {showCTA ?
            <CallToActionModal 
            setShowCTA={setShowCTA}
            showCTA={showCTA}
            callToAction={callToAction}
            profile={profile}
            />
            :
            null
            }
        </div>
    )
}

export default MainMessaging
